import React from 'react';

interface Props {
  children: React.ReactNode
};

interface State {
  hasError: boolean,
  error: Error | null
};

class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="text-center m-5">
          <h2>Something went wrong / Une erreur est survenue</h2>
          <p className="text-muted">{this.state.error?.message}</p>
          <button className="btn btn-primary me-3" onClick={() => window.location.reload()}>
            Reload / Recharger
          </button>
          <a className="btn btn-secondary" href="/auth/login">
            Login
          </a>
        </div>
      )
    }
    return this.props.children
  }
};

export default ErrorBoundary;
